import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import ContactModalComponent from "@/components/contact/ContactModal.component";
import ReserveModalComponent from "@/components/reserve/ReserveModal.component";
import { ContactProvider } from "@/context/ContactProvider.context";
import { ReserveProvider } from "@/context/ReserveProvider.context";

import i18n from "../i18n";

const ScheduleComponent: React.FC = () => {
  const { t } = i18n;

  return (
    <Container
      style={{
        backgroundColor: "#F9F8F8",
        textAlign: "center",
        padding: "2.5rem 2rem",
        margin: "3rem auto",
        borderRadius: "20px",
      }}
    >
      <Row>
        <Col xs={12}>
          <h2>{t("Revolutionary Modular Buildings")}</h2>
          <p className="mt-4 mb-4">
            {t(
              "Experience the future of sustainable living with PakVille's innovative modular buildings. Quick assembly, eco-friendly materials, and stunning designs.",
            )}
          </p>
        </Col>

        <Col lg={{ span: 6, offset: 3 }} xs={12}>
          <div className="d-flex mt-4 mb-4 justify-content-between align-items-center gap-4">
            <ContactProvider>
              <ContactModalComponent
                btnClass="flex-grow-1 flex-shrink-1 flex-basis-0 p-2"
                btnVariant="primary"
              />
            </ContactProvider>

            <ReserveProvider>
              <ReserveModalComponent
                btnClass="flex-grow-1 flex-shrink-1 flex-basis-0 p-2"
                btnVariant="outline-primary"
              />
            </ReserveProvider>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ScheduleComponent;
